export const PHOTO_STATUS_OPTIONS = [
  { label: '全部', value: '' },
  { label: '有照片', value: 1 },
  { label: '无照片', value: 0 }
]

export const INTERVIEW_IMPORT_SYSTEM_FIELDS = [
  '_id',
  'examId',
  'delete',
  'updateOperator',
  'updateTime',
  'interviewPrintNumber',
  'associate',
  'userId'
]

export const DELETE_CONFIRM_CONTENT =
  '删除后将同步清除考生照片关联及所有考场记录，操作不可恢复，确认删除？'

export const ALLOWED_PHOTO_EXT = ['jpg', 'jpeg', 'png']

export const isInterviewDeleteDisabled = (examinationStatus) => {
  return examinationStatus === 4
}

export const validateIdCard = (value) => {
  if (!value) {
    return true
  }
  return /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/.test(String(value).trim())
}

export const validatePhotoFile = (file) => {
  const ext = file.name.split('.').pop()?.toLowerCase()
  return ALLOWED_PHOTO_EXT.includes(ext)
}

export const buildInterviewSaveData = (formValues, templateFields) => {
  const data = {}

  templateFields?.forEach(field => {
    if (!field.fieldCode || field.fieldCode === 'personalPhoto') {
      return
    }
    if (INTERVIEW_IMPORT_SYSTEM_FIELDS.includes(field.fieldCode)) {
      return
    }
    const value = formValues[field.fieldCode]
    if (value !== undefined && value !== null) {
      data[field.fieldCode] = value
    }
  })

  if (formValues.personalPhoto != null && formValues.personalPhoto !== '') {
    data.personalPhoto = formValues.personalPhoto
  }

  return data
}

export const parseSelectContentOptions = (selectContent) => {
  if (!selectContent) {
    return []
  }

  return selectContent.split('|').map(item => {
    const [label, value] = item.split('-')
    return {
      label: label || item,
      value: value ?? label ?? item
    }
  })
}
